export default {
  title_1_1: 'Secret',
  title_1_2: 'Safe Box',
  desc_1_2: 'Sólido, seguro y fácil',

  title_2_1: 'Nuevo',
  title_2_2: 'Diseño',
  desc_2_1:
    'Proceso de producción láser completo: panel más grueso y mayor capacidad de protección',
  desc_2_2: 'Más tornillos y más seguros, ajuste más firme',
  desc_2_3: 'Admite 2 conjuntos de mnemónicos de 12 palabras',
  desc_2_4:
    'Proceso láser completo / panel más grueso y protección mejorada / más tornillos y seguros / admite 2×12 palabras',

  title_3_1_1: 'Impresionantes',
  title_3_1_2: 'características 3 en 1',
  desc_3_1:
    'Cuerpo fabricado con acero inoxidable 304: resistente al fuego, al calor y a la corrosión',
  desc_3_2: 'A prueba de agua',
  desc_3_3_1: 'Material de acero inoxidable 304 refinado',
  desc_3_3_2: 'Impermeable y anticorrosión',
  desc_3_3_3: 'Amigable con entornos de almacenamiento',
  desc_3_3_4: 'Protege las claves con facilidad',
  desc_3_4: 'A prueba de fuego',
  desc_3_5_1: 'Temperatura de fusión muy alta',
  desc_3_5_2: 'Excelente rendimiento frente al fuego',
  desc_3_5_3: 'Mantén seguras tus claves',
  desc_3_5_4: 'incluso en incendios inesperados',
  desc_3_6: 'A prueba de golpes',
  desc_3_7_1: 'Proceso de fabricación de alta resistencia',
  desc_3_7_2: 'Paneles más gruesos para un encaje más firme',
  desc_3_7_3: 'incluso ante golpes imprevistos',
  desc_3_7_4: 'Protege firmemente cada carácter del interior',

  title_4_1: 'Panel de alfabeto',
  desc_4_1_1: 'Versión Pro del panel de alfabeto',
  desc_4_1_2: 'Más conveniente, más eficiente',
  desc_4_2_1:
    'Nuevo diseño: 6 paneles desmontables que generan 351 bloques',
  desc_4_2_2:
    'Admite mayúsculas y minúsculas; añade números y símbolos',
  desc_4_2_3:
    'Diseño de doble cara: hasta 702 caracteres visibles',
  desc_4_3: '351 bloques',
  desc_4_4: 'Mayúsculas/minúsculas',
  desc_4_5: 'Números/símbolos',
  desc_4_6: 'Doble cara',

  title_5_1: 'Diagrama de operación',
  desc_5_1:
    'Compatible con la extensión de monedero web. Perfectamente adaptado a TokenPocket, combinando seguridad y facilidad de uso.',
  desc_5_2: 'Paso 01',
  desc_5_3: 'Despliega el panel frontal y abre en sentido antihorario',
  desc_5_4: 'Paso 02',
  desc_5_5: 'Afloja los 5 tornillos con un destornillador',
  desc_5_6: 'Paso 03',
  desc_5_7: 'Levanta el panel de la cubierta',
  desc_5_8: 'Paso 04',
  desc_5_9: 'Introduce los caracteres en las ranuras',
  desc_5_10: 'Paso 05',
  desc_5_11:
    'Tras verificar, cierra el panel frontal y aprieta los 5 tornillos',

  title_6_1: 'Especificaciones / Paquete',
  desc_6_1: 'Secret Box Pro',
  desc_6_2:
    'Frente a la copia en papel, Secret Box Pro prioriza la seguridad y la comodidad: fácil de desmontar y montar; colocar los bloques es rápido y sencillo.',
  desc_6_3: 'Panel de alfabeto',
  desc_6_4:
    'Frente a la copia en papel, Secret Box Pro prioriza la seguridad y la comodidad: fácil de desmontar y montar; colocar los bloques es rápido y sencillo.',
  desc_6_5: 'Bolsa EVA',
  desc_6_6:
    'Frente a la copia en papel, Secret Box Pro prioriza la seguridad y la comodidad: fácil de desmontar y montar; colocar los bloques es rápido y sencillo.',
  desc_6_7: 'Folleto/tornillos/destornillador',
  desc_6_8:
    'Frente a la copia en papel, Secret Box Pro prioriza la seguridad y la comodidad: fácil de desmontar y montar; colocar los bloques es rápido y sencillo.',

  title_7_1: 'Especificaciones técnicas',
  title_7_2: 'Funciones y uso',
  desc_7_1: 'Especificaciones de Secret Box',
  desc_7_2: 'Tamaño',
  desc_7_3: 'Peso',
  desc_7_4: 'Especificaciones del panel de alfabeto',
  desc_7_5: 'Juego de 3 piezas, 351 bloques en total',
  desc_7_6: 'Admite múltiples conjuntos de mnemónicos',
  desc_7_7:
    'Admite 2×12 palabras o 1×18/24 palabras conforme a BIP39.',
  desc_7_8: 'Almacenamiento fuera de línea',
  desc_7_9:
    'El almacenamiento offline elimina la posibilidad de robo de claves a través de la red',
  desc_7_10: 'Materiales de alta calidad',
  desc_7_11:
    'El acero inoxidable robusto es ideal para conservar mnemónicos a largo plazo, lejos del riesgo de pérdida.',
};
